module.exports = "/_next/static/images/shipalt-b09f9cd50f2bc2287b248206c5df513d.svg";